import React from 'react'
import { FormCheckbox, FormInput } from '@myxplor/forms'

const CancelCertificateForm = ({ values, onChange }) => {
  return (
    <fieldset>
      <legend>Cancel ACCS Certificate</legend>
      <FormInput
        required
        label='Reason For Cancellation'
        name='cancelation_reason'
        value={values.cancelation_reason}
        type='text'
        autoFocus={false}
        onChange={onChange}
      />
      <FormCheckbox
        required
        label='I confirm that the information provided is true and correct'
        name='is_declaration_given'
        value={values.is_declaration_given}
        onChange={onChange}
        compact
      />
      By canceling the certificate, they will stop receiving additional subsidy.
      Do you wish to cancel?
    </fieldset>
  )
}

export default CancelCertificateForm



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/cancel-certificate.js